import React from 'react';
import { Navigate } from 'react-router-dom';
import { authUtils } from '../utils/auth';

function PrivateRoute({ children }) {
  return authUtils.isAuthenticated() ? children : <Navigate to="/login" replace />;
}

export default PrivateRoute;
